import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRSIC_VFC_OTP;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },
};
